import { readOnly } from '@ember/object/computed';
import Controller from '@ember/controller';
import {
  TYPE_CONDITION_TRIGGERED,
  TYPE_EVENT_TRIGGERED,
  TYPE_CAMPAIGN,
  TYPE_BROADCAST,
  TYPE_NEWSLETTER,
  TYPE_DASHBOARD,
  TYPE_SQL_IMPORT,
} from 'cio/utils/segment-usage';
import { SEGMENT_TYPES } from 'cio/models/segment';

export default class UsageController extends Controller {
  TYPE_CONDITION_TRIGGERED = TYPE_CONDITION_TRIGGERED;
  TYPE_EVENT_TRIGGERED = TYPE_EVENT_TRIGGERED;
  TYPE_CAMPAIGN = TYPE_CAMPAIGN;
  TYPE_BROADCAST = TYPE_BROADCAST;
  TYPE_NEWSLETTER = TYPE_NEWSLETTER;
  TYPE_DASHBOARD = TYPE_DASHBOARD;
  TYPE_SQL_IMPORT = TYPE_SQL_IMPORT;

  @readOnly('model.usage') usage;
  @readOnly('model.type') type;

  types = SEGMENT_TYPES;
}
